export default __webpack_public_path__ + "static/B0125-eee8929528eb2fd04421b0424c805073.png";